import { DriverV2Output } from '@allocab/allocab-driver-service-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { driverApi } from '../services/network/Api';

const fetchDriver = (id: string) => driverApi.get<void, DriverV2Output>(`/v1/driver/id/${id}`);

export const useFetchDriver = (id: string) => useQuery(queryKeys.user.fetchDriver(id), () => fetchDriver(id));
